import { useState, useEffect } from 'react';
import api from '../api/client';
import CardGrid from '../components/CardGrid'
import Header from './Header'
import Seo from '../components/Seo'
import "./Home.css"

function Home({ translations }) {
    const [artworks, setArtworks] = useState([]);
    const [loading, setLoading] = useState(true);
    const darkMode = useState(false);

    useEffect(() => {
        api.getHomeFeed(0, 20)
        .then(setArtworks)
        .catch(() => setArtworks([]))
        .finally(() => setLoading(false));
    }, []);

    return (
        <div className={darkMode ? "app dark" : "app"}>
            <Seo
                description="Discover and buy original art from independent artists on ArtSyde — paintings, drawings, digital art, sculpture and photography. Follow creators and support the art community."
            />
            <div>
                <Header translations={translations} />
                <div className='body-page'>
                    <div className='parts'>
                        <div className='top-part'>
                            <p className='title-categories'>{translations['home-title']}</p>
                        </div>
                        <div id='all-cards' className='box-table'>
                            {loading ? (
                                <div className="loading-page"><div className="spinner" /></div>
                                ) : (
                                    <CardGrid pictures={artworks} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;